import { useState } from 'react'
import type { CustomerBalance } from '../api/types'
import { Amt, Card, Empty, Note, PageHead, TotalBox } from '../components/ui'
import { useApi } from '../hooks/useApi'
import { formatMoney } from '../lib/format'

/** Everyone who owes the shop money, biggest first. */
export function Balances() {
  const [includeSettled, setIncludeSettled] = useState(false)
  const balances = useApi<CustomerBalance[]>(
    `/customers/balances?includeSettled=${includeSettled}`,
    [includeSettled],
  )

  const rows = balances.data ?? []
  const owed = rows
    .filter((row) => Number(row.totals.balance) > 0)
    .reduce((sum, row) => sum + Number(row.totals.balance), 0)

  return (
    <>
      <PageHead title="بقایا" hint="کس کے ذمے کتنا ہے، بڑی رقم پہلے۔" />

      {balances.error && <Note kind="error">{balances.error}</Note>}

      <div className="totals">
        <TotalBox label="کتنے گاہک" value={<span className="amt">{rows.length}</span>} />
        <TotalBox label="کل بقایا" value={<Amt value={owed} />} accent />
      </div>

      <Card
        title="لسٹ"
        actions={
          <label style={{ fontSize: 14, display: 'flex', gap: 6, alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={includeSettled}
              onChange={(e) => setIncludeSettled(e.target.checked)}
            />
            جن کا حساب برابر ہے وہ بھی دکھائیں
          </label>
        }
      >
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>گاہک</th>
                <th className="col-extra">فون</th>
                <th className="col-extra">کل فروخت</th>
                <th className="col-extra">کل ادائیگی</th>
                <th>بقایا</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.customer.id}>
                  <td className="name-cell">
                    {row.customer.name}
                    {/*
                      The same two figures the wide screen gives their own
                      columns. Five columns will not fit across a phone, and
                      dropping these two left the page answering "how much" with
                      no way to see how it got there - what he has taken against
                      what he has handed back is the whole of the story behind a
                      بقایا. Under the name they cost one line and no width.
                    */}
                    <span className="row-sub">
                      فروخت <b>{formatMoney(row.totals.totalSale)}</b> · دیا{' '}
                      <b>{formatMoney(row.totals.totalPaid)}</b>
                    </span>
                  </td>
                  <td className="num col-extra">{row.customer.phone ?? '—'}</td>
                  <td className="num col-extra">
                    <Amt value={row.totals.totalSale} tone="muted" />
                  </td>
                  <td className="num col-extra">
                    <Amt value={row.totals.totalPaid} tone="muted" />
                  </td>
                  <td className="num">
                    <Amt value={row.totals.balance} tone="balance" />
                  </td>
                </tr>
              ))}

              {rows.length > 0 && (
                <tr className="is-total">
                  <td>کل</td>
                  <td className="col-extra" colSpan={3}></td>
                  <td className="num">{formatMoney(owed)}</td>
                </tr>
              )}

              {rows.length === 0 && !balances.loading && (
                <tr>
                  <td colSpan={5}>
                    <Empty>کسی کے ذمے کچھ نہیں۔</Empty>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </>
  )
}
